import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-5890 — the base a chat share link (authenticated or public) is
// built on. A server that routes phone links through the mobile link
// redirector publishes `deployment.links.shareBaseUrl`, and a link built on it
// opens the app on a phone that has it and the web app everywhere else. Absent
// — the default, and the state while /app-config is still loading — it is the
// browser's own origin, so the link keeps working behind a custom domain or an
// on-prem reverse proxy. The path itself is added by the frontend-shared
// builders, so mobile produces the very same link (NSAI-4322). Meeting and page
// share links stay on the origin: the app has no screen for them yet.
export const useShareLinkBase = (): string => {
  const { data } = useAppConfig();

  return data?.deployment?.links?.shareBaseUrl ?? globalThis.location.origin;
};
